module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"interviews":"отклик | отклика | откликов","sms":"SMS","calls":"звоноков | звонок | звонка | звонков"}}')
  delete Component.options._Ctor
}
